import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

var shuffle = function shuffle() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var a = text.split('');
  var n = a.length;

  for (var i = n - 1; i > 0; i -= 1) {
    // eslint-disable-line no-plusplus
    var j = Math.floor(Math.random() * (i + 1));
    var tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }

  return a.join('');
};

export default function getSsdge(token) {
  var auth = uuidv5(token, uuidv4()).replace(/-/gi, '').split('');
  auth[4] = shuffle('2468')[0];
  return auth.join('');
}